module.exports = __webpack_public_path__ + "static/media/PDF_50.35b4eda9.pdf";